import React from 'react';

import { designSystem } from '@/styles/theme';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const NavJobIcon: React.FC<IconProps> = ({ width = 24, height = 24, color = designSystem.colors.primary }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="7" width="20" height="13" rx="2" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7" stroke={color} strokeWidth="2" fill="none"/>
    <line x1="2" y1="12" x2="22" y2="12" stroke={color} strokeWidth="2"/>
    <rect x="10" y="10" width="4" height="4" rx="0.5" stroke={color} strokeWidth="1.5" fill="none"/>
  </svg>
);

export default NavJobIcon;
